export default "__VITE_ASSET__5d5bb01f__"